import { useEffect, useCallback } from "react";
import { useParameter, useFavouriteProviderContext } from "../../../shared";

import { useSlideTitle } from "../hooks/useSlideTitle";

export function useFavourite() {
  const title = useSlideTitle();
  const {
    actions: { setParameters, setApplyFunction },
  } = useFavouriteProviderContext();

  const [commodityDisplay, setCommodityDisplay] = useParameter<number>("@commodities_display");
  const [commodityValue, setCommodityValue] = useParameter<number>("@commodities");
  const [refYearvalue, setRefYearValue] = useParameter<number>("@ref_year");

  useEffect(() => {
    setParameters(title, {
      "@commodities_display": commodityDisplay,
      "@commodities": commodityValue,
      "@ref_year": refYearvalue,
    });
  }, [title, commodityDisplay, commodityValue, refYearvalue, setParameters]);

  const applyParameters = useCallback(
    (parameters: Record<string, string[]>) => {
      setCommodityDisplay(parameters["@commodities_display"].map(Number)[0]);
      setCommodityValue(parameters["@commodities"].map(Number)[0]);
      setRefYearValue(parameters["@ref_year"].map(Number)[0]);
    },
    [setCommodityDisplay, setCommodityValue, setRefYearValue]
  );

  useEffect(() => {
    setApplyFunction(applyParameters);
  }, [setApplyFunction, applyParameters]);
}
